module.exports = __webpack_public_path__ + "static/media/coriandoli.ab2fe5a1.png";